export const VE_BANK_ASSETS = {
  appIcon: 'https://cdn.magicpatterns.com/uploads/gM8t4qQasnM5avPFeiTMkt/ve-bank-app-icon-final.png',
  wordmark: 'https://cdn.magicpatterns.com/uploads/frU1aUkKEwqARJ34PcYni4/ve-bank-wordmark-v2.png',
  vee: 'https://cdn.magicpatterns.com/uploads/aP4xLjfvzKZULUU4W7GbDx/image.png',
  veeListening: 'https://cdn.magicpatterns.com/uploads/aP4xLjfvzKZULUU4W7GbDx/image.png',
  portraitMosaic: 'https://cdn.magicpatterns.com/uploads/jEKYmJThc5mBXmLMcL2ZBU/ve-bank-landing-portrait-mosaic-v2.png',
  flowRibbon: 'https://cdn.magicpatterns.com/uploads/mTEtHyzyYjU57FrYCagKdm/ve-bank-flow-ribbon-v2.png',
  cashflowStory: 'https://cdn.magicpatterns.com/uploads/eghzbX1PD6NbZjLnmcFMRL/ve-bank-cashflow-story-v2.png',
  biometricReview: 'https://cdn.magicpatterns.com/uploads/sMZWxq343JjBQuayLakpZZ/ve-bank-biometric-review-v2.png',
  actionSend: 'https://cdn.magicpatterns.com/uploads/9jCF2rfLiJviEH6nkAhcnv/pasted-image.svg',
  actionAirtime: 'https://cdn.magicpatterns.com/uploads/q7wwkk6MVzJDjWysSCWJC7/pasted-image.svg',
  actionBills: 'https://cdn.magicpatterns.com/uploads/iLzxJwXD8aPCfmET4s5RyX/pasted-image.svg',
  actionCards: 'https://cdn.magicpatterns.com/uploads/841byhZRv1oqZMnWwG4Dxw/pasted-image.svg',
} as const

export const ACCOUNT_NAME = 'VE Bank Account'
export const ACCOUNT_NUMBER = '0803 123 4567'
export const AVAILABLE_BALANCE = '₦125,680.50'
export const USER_NAME = 'Chidi Okeke'

export const transactionData = [
  { id: 'veb-84729104', title: 'Ada Okafor', detail: 'Transfer · Today, 09:42', amount: '−₦25,000.00', type: 'out', icon: 'send' },
  { id: 'veb-52710177', title: 'Airtel airtime', detail: 'Airtime · Yesterday, 14:30', amount: '−₦2,000.00', type: 'out', icon: 'airtime' },
  { id: 'veb-12346781', title: 'Obi Nwosu', detail: 'Transfer received · 21 Jul', amount: '+₦50,000.00', type: 'in', icon: 'receive' },
  { id: 'veb-46291026', title: 'Ikeja Electric', detail: 'Bill payment · 20 Jul', amount: '−₦15,500.00', type: 'out', icon: 'electricity' },
] as const
